import { Option } from '@/class/Option';
import Select from '../../../utils/select';
import {
  adminInput,
  adminButtonPrimary,
  adminSectionTitle,
  adminModalPanel,
} from '../../layout/adminStyles';
import React, { FC, FormEvent } from 'react';

export type ItemEditForm = {
  item_name: string;
  furigana: string;
  category_id: string;
  level: string;
};

type Props = {
  isShowModal: boolean;
  itemId: number | null;
  editForm: ItemEditForm;
  categoryOptions: Option[];
  isSaving: boolean;
  onChange: (form: ItemEditForm) => void;
  onClose: () => void;
  onSubmit: () => void;
};

const ItemEditModal: FC<Props> = ({
  isShowModal,
  itemId,
  editForm,
  categoryOptions,
  isSaving,
  onChange,
  onClose,
  onSubmit,
}) => {
  if (!isShowModal || itemId == null) {
    return null;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="item-edit-modal-title"
    >
      <div className={adminModalPanel}>
        <div className="mb-4 flex items-center justify-between border-b border-stone-200 pb-3">
          <h2 id="item-edit-modal-title" className={adminSectionTitle + ' mb-0 border-0 pb-0'}>
            商品編集
          </h2>
          <button
            type="button"
            className="text-2xl leading-none text-stone-500 hover:text-stone-800"
            onClick={onClose}
            aria-label="閉じる"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="mb-1 block text-sm font-medium text-stone-700">ID</label>
            <p className="text-stone-800">{itemId}</p>
          </div>

          <div className="mb-4">
            <label htmlFor="edit-item-name" className="mb-1 block text-sm font-medium text-stone-700">
              商品名
            </label>
            <input
              id="edit-item-name"
              type="text"
              required
              className={`${adminInput} w-full`}
              value={editForm.item_name}
              onChange={(e) => onChange({ ...editForm, item_name: e.target.value })}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="edit-furigana" className="mb-1 block text-sm font-medium text-stone-700">
              ふりがな
            </label>
            <input
              id="edit-furigana"
              type="text"
              className={`${adminInput} w-full`}
              value={editForm.furigana}
              onChange={(e) => onChange({ ...editForm, furigana: e.target.value })}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="edit-category" className="mb-1 block text-sm font-medium text-stone-700">
              カテゴリ
            </label>
            <Select
              options={categoryOptions}
              value={editForm.category_id}
              cssClass={`${adminInput} w-full`}
              onChange={(value) => onChange({ ...editForm, category_id: value })}
            />
          </div>

          <div className="mb-6">
            <label htmlFor="edit-level" className="mb-1 block text-sm font-medium text-stone-700">
              レベル
            </label>
            <Select
              options={[
                { id: '1', name: 'LIGHT' },
                { id: '2', name: 'その他' },
              ]}
              value={editForm.level}
              cssClass={`${adminInput} w-full`}
              onChange={(value) => onChange({ ...editForm, level: value })}
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-xl border border-stone-300 px-5 py-2 text-stone-700 hover:bg-stone-50"
              onClick={onClose}
              disabled={isSaving}
            >
              キャンセル
            </button>
            <button type="submit" className={adminButtonPrimary} disabled={isSaving}>
              {isSaving ? '保存中...' : '保存'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ItemEditModal;
